// extracted by mini-css-extract-plugin
export default {"section":"OurExpertise_section__LA38u","container":"OurExpertise_container__3RguN","grid":"OurExpertise_grid__fypQC"};